import {syncTranslationWithStore, I18n} from 'react-redux-i18n';
import moment from 'moment';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import {setupI18n} from '../../I18n';
import storeProvider from '../../store';

import en from './languages/en.yml';
import pt from './languages/pt.yml';
import pl from './languages/pl.yml';
import nl from './languages/nl.yml';
import fr from './languages/fr.yml';
import de from './languages/de.yml';
import es from './languages/es.yml';
import it from './languages/it.yml';

const store = storeProvider.getStore();

I18n.setHandleMissingTranslation((text, repl) => {
  if (repl.length > 0) return repl;
  if (text && text.length > 0) return text.split('.').pop();
  return null;
});

export const availableLanguages = [
  'en-us',
  'pt-br',
  'pl',
  'nl',
  'fr',
  'de',
  'es',
  'it'
];

export const defaultLanguage = 'en-us';

const availableTranslations = {
  en,
  pt,
  pl,
  nl,
  fr,
  de,
  es,
  it
};

forEach(availableTranslations, (translation, language) => {
  const localeConfig = {
    relativeTime: get(translation, 'configuration.relativeTime')
  };

  moment.defineLocale(language, localeConfig);

  const locale = get(translation, 'configuration.location');

  if (locale && locale !== language) {
    moment.defineLocale(locale, localeConfig);
  }
});

export const setupTranslation = (_language = defaultLanguage) => {
  let language = _language;

  if (language.indexOf('-') > -1) {
    [language] = language.split(/[_-]+/);
  }

  const locale = get(availableTranslations, `${language}.configuration.location`, language);
  moment.locale(locale);

  setupI18n({
    store,
    language,
    translations: availableTranslations
  }, syncTranslationWithStore);
};

export default setupTranslation;
